import { ICustomer } from "@middleware/types";
import {
  BAR_BILAN_CODE,
  BAR_MAIL_CAPTURE_CODE,
  BAR_REFERRAL_CODE,
  POPUP_MAIL_CAPTURE_CODE,
  POPUP_REFERRAL_CODE,
} from "@middleware/constants";
import { NextRouter } from "next/router";
import { getIsProspect } from "./customer";
import { isDurationPage } from "./urls";

export const getActiveBar = (
  router: NextRouter,
  bilanPassed: boolean,
  bilanBarActivation?: boolean,
  customer?: ICustomer,
  captureMailBarActivation?: boolean,
  referralFormBarActivation?: boolean,
) => {
  const isProspectNotConnected = customer === undefined;
  const isProspect = getIsProspect(customer);
  const showBilanBar =
    isDurationPage(router) && !bilanPassed && bilanBarActivation === true;

  if (showBilanBar) {
    return BAR_BILAN_CODE;
  }

  if (captureMailBarActivation === true && isProspectNotConnected) {
    return BAR_MAIL_CAPTURE_CODE;
  }

  if (referralFormBarActivation === true && !isProspect) {
    return BAR_REFERRAL_CODE;
  }

  return;
};
export const getActivePopup = (
  customer?: ICustomer,
  captureMailActivation?: boolean,
  referralFormActivation?: boolean,
) => {
  const isProspectNotConnected = customer === undefined;
  const isProspect = getIsProspect(customer);

  if (captureMailActivation === true && isProspectNotConnected) {
    return POPUP_MAIL_CAPTURE_CODE;
  }

  if (referralFormActivation === true && !isProspect) {
    return POPUP_REFERRAL_CODE;
  }

  return;
};
